import { ProductOption } from "./option.base";

export class VlaicuOption extends ProductOption {
  getBuyLink(): string {
    const buyLinkUrl = new URL(super.getBuyLink());
    buyLinkUrl.searchParams.set("SHOPURL", `${window.location.origin}/${window.location.pathname.split('/')[1]}/`);
    buyLinkUrl.searchParams.set("SRC", `${window.location.origin}${window.location.pathname}`);

    return buyLinkUrl.href;
  }
}